import type { ProbablyDate } from "@eroad/types";

import { isDefined } from "../utils/isDefined";
import { canBeValidDate } from "./canBeValidDate";
import { dayjs } from "./dayjs";

/**
 * Gets the number of full minutes periods between two dates.
 *
 * If one of the dates is not defined, returns NaN.
 * If one of the dates is invalid, returns NaN.
 *
 * @example
 * ```ts
 * const earlierDate = new Date("2022-01-01T03:00:00Z");
 * const laterDate = new Date("2022-01-01T03:24:00Z");
 *
 * differenceInMinutes(laterDate, earlierDate); // 24
 * differenceInMinutes(earlierDate, laterDate); // -24
 * ```
 */
function differenceInMinutes(laterDate: ProbablyDate, earlierDate: ProbablyDate): number {
  if (!isDefined(laterDate) || !isDefined(earlierDate)) {
    return NaN;
  }

  if (!canBeValidDate(laterDate) || !canBeValidDate(earlierDate)) {
    return NaN;
  }

  return dayjs(laterDate).diff(earlierDate, "minutes");
}

export { differenceInMinutes };
